import { render, staticRenderFns } from "./continuity-modal.vue?vue&type=template&id=2b954e78"
import script from "./continuity-modal.vue?vue&type=script&lang=js"
export * from "./continuity-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports